import { Zap, ShieldCheck, Truck, HardHat, Clock } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { SectionHeading } from "@/components/ui/section-heading";

const reasonsEn = [
  { icon: Zap, title: "Fast Mobilization Across KSA", desc: "Rapid deployment to any site, anywhere in the Kingdom." },
  { icon: HardHat, title: "Skilled & Experienced Workforce", desc: "Trained crews ready for demanding industrial sites." },
  { icon: Truck, title: "Reliable Equipment & Materials", desc: "Well-maintained equipment and quality materials, every time." },
  { icon: ShieldCheck, title: "Safety-Focused Operations", desc: "Strict HSE standards on every job we deliver." },
  { icon: Clock, title: "On-Time Project Execution", desc: "We respect your schedule — and stick to it." },
];

const reasonsAr = [
  { icon: Zap, title: "تعبئة سريعة في المملكة", desc: "نشر سريع لأي موقع في أي مكان بالمملكة." },
  { icon: HardHat, title: "عمالة ماهرة وذات خبرة", desc: "فرق مدرّبة جاهزة للمواقع الصناعية الصعبة." },
  { icon: Truck, title: "معدات ومواد موثوقة", desc: "معدات حسنة الصيانة ومواد عالية الجودة في كل مرة." },
  { icon: ShieldCheck, title: "عمليات ترتكز على السلامة", desc: "معايير HSE صارمة في كل عمل نقدمه." },
  { icon: Clock, title: "تنفيذ المشاريع في الوقت المحدد", desc: "نحترم جدولك الزمني ونلتزم به." },
];

const WhyChooseUs = () => {
  const { language } = useLanguage();
  const isAr = language === 'ar';
  const reasons = isAr ? reasonsAr : reasonsEn;
  const eyebrow = isAr ? "لماذا تختارنا" : "Why Choose Us";
  const h1 = isAr ? "مبنيون على الثقة." : "Built on Trust.";
  const h2 = isAr ? "مدفوعون بالحرفية." : "Driven by Craft.";
  return (
    <section id="why-us" data-on-dark className="py-20 bg-primary-darker text-primary-foreground relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]" style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, hsl(var(--accent)) 1px, transparent 0)`,
        backgroundSize: '36px 36px',
      }} />
      <div className="container mx-auto px-6 lg:px-8 relative">
        <SectionHeading
          centered
          onDark
          eyebrow={eyebrow}
          accent={h2}
          wrapperClassName="mb-14 max-w-2xl"
        >
          {h1}
        </SectionHeading>
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {reasons.map((r) => (
            <div key={r.title} className="bg-primary-foreground/5 border border-accent/20 rounded-xl p-6 text-center hover:border-accent transition-smooth backdrop-blur-sm">
              <div className="w-14 h-14 mx-auto rounded-full bg-accent/15 flex items-center justify-center mb-4">
                <r.icon className="w-7 h-7 text-accent" />
              </div>
              <h3 className="font-bold text-lg mb-2 text-primary-foreground">{r.title}</h3>
              <p className="text-sm text-primary-foreground/70 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;